import ProductIcon, { pickProductIcon } from './ProductIcon';

export default ProductIcon;
export { pickProductIcon };